import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import {
  Tooltip,
  Box,
  Button,
  Card,
  CardContent,
  Tabs,
  Tab,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Switch,
  FormControlLabel
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WorkflowSupplier } from '../../../interfaces/Workflow';
import {
  Organization,
  OrganizationInterface,
  OrganizationSupplier
} from '../../../interfaces/Organization';
import { IWorkflowService } from '../../../services/Interfaces/IWorkflowService';
import NumberFormat from 'react-number-format';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import {
  ReferentialCode,
  OrganizationTypeCode,
  SupplierApiType,
  Descripted,
  enumToDescriptedArray
} from '../../../helpers/Constants';
import * as R from 'ramda';
import { X } from 'react-feather';
import TabPanel from '../../_shared/Tabs';

interface IOrganizationSupplierState {
  newOrganizationSupplier: OrganizationSupplier | null;
  organizationSuppliers: OrganizationSupplier[];
  isLoading: boolean;
  organizationSupplierTypes: Organization[];
  organizationSupplierInterfaceTypes: OrganizationInterface[];
  selectedOrganizationSupplierType: Organization | null;
  selectedOrganizationSupplierInterfaceType: OrganizationInterface | null;
  urlInterface: string;
  discountTariff: number;
  userName: string;
  password: string;
  port: number | null;
  organizationId: number;
  isDialogOpen: boolean;
  organizationSupplierId: number | null;
  supplierApiType: Descripted<typeof SupplierApiType> | null;
  supplierApiTypes: Descripted<typeof SupplierApiType>[];
  clientId: string;
  hasNonStockValidation: boolean;
  isActive: boolean;
}

type IOrganizationSupplierProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string }>;

class OrganizationSuppliers extends React.PureComponent<
  IOrganizationSupplierProps,
  IOrganizationSupplierState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  private workflowService!: IWorkflowService;

  static contextType = ApplicationContext;
  state = {
    newOrganizationSupplier: null,
    organizationSuppliers: [],
    organizationSupplierTypes: [],
    organizationSupplierInterfaceTypes: [],
    selectedOrganizationSupplierType: null,
    selectedOrganizationSupplierInterfaceType: null,
    urlInterface: '',
    discountTariff: 0,
    userName: '',
    password: '',
    port: 0,
    organizationId: 0,
    isLoading: false,
    isDialogOpen: false,
    organizationSupplierId: null,
    supplierApiType: null,
    supplierApiTypes: enumToDescriptedArray(SupplierApiType),
    clientId: '',
    hasNonStockValidation: false,
    isActive: true
  } as IOrganizationSupplierState;

  public componentDidMount() {
    const hoId = Number.parseInt(this.props.match.params.id);

    if (Number.isNaN(hoId)) {
      return;
    }

    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadOrganizationSuppliers();
      }
    );
  }

  loadOrganizationSuppliers = async () => {
    const hoId = Number.parseInt(this.props.match.params.id);
    if (Number.isNaN(hoId)) {
      return;
    }

    const [os, organizationSuppliers] = await Promise.all([
      this.organizationService.GetOrganizationSuppliers(hoId),
      this.organizationService.GetHOOrganizationsByTypes([OrganizationTypeCode.SUPPLIER])
    ]);

    const interfacePromises = [] as any[];
    const supplierIds: number[] = [];

    os.forEach((os) => {
      const supplier = organizationSuppliers.find((item) => item.id === os.supplierId);
      if (supplierIds.indexOf(os.supplierId) === -1) {
        supplierIds.push(os.supplierId);
        interfacePromises.push(this.organizationService.GetOrganizationInterfaces(os.supplierId));
      }

      os.supplier = R.isNil(supplier) ? null : supplier;
    });

    const result = await Promise.all(interfacePromises);

    const organizationInterfaces: OrganizationInterface[] = [];
    result.forEach((item) => {
      organizationInterfaces.push(...item);
    });

    os.forEach((os) => {
      const suppInterface = organizationInterfaces.find(
        (item) => item.id === os.supplierInterfaceId
      );
      os.supplierInterface = R.isNil(suppInterface) ? null : suppInterface;
    });

    this.setState({
      organizationSupplierTypes: organizationSuppliers.filter((item) => item.isActive === true),
      isLoading: false,
      organizationId: hoId,
      organizationSuppliers: os
    });
  };

  handleIsActiveChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    tableMeta: MUIDataTableMeta
  ) => {
    const id = tableMeta.rowData[0];
    const organizationSuppliers = [...this.state.organizationSuppliers];
    const updatedOrganizationSupplierIndex = organizationSuppliers.findIndex((o) => o.id === id);

    if (updatedOrganizationSupplierIndex >= 0) {
      organizationSuppliers[updatedOrganizationSupplierIndex] = {
        ...organizationSuppliers[updatedOrganizationSupplierIndex],
        isActive: event.target.checked
      };

      try {
        await this.organizationService.UpdateOrganizationSupplier(
          organizationSuppliers[updatedOrganizationSupplierIndex]
        );

        this.setState({ organizationSuppliers: organizationSuppliers });

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  handleHasNonStockValidationChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    tableMeta: MUIDataTableMeta
  ) => {
    const id = tableMeta.rowData[0];
    const organizationSuppliers = [...this.state.organizationSuppliers];
    const updatedOrganizationSupplierIndex = organizationSuppliers.findIndex((o) => o.id === id);

    if (updatedOrganizationSupplierIndex >= 0) {
      organizationSuppliers[updatedOrganizationSupplierIndex] = {
        ...organizationSuppliers[updatedOrganizationSupplierIndex],
        hasNonStockValidation: event.target.checked
      };

      try {
        await this.organizationService.UpdateOrganizationSupplier(
          organizationSuppliers[updatedOrganizationSupplierIndex]
        );

        this.setState({ organizationSuppliers: organizationSuppliers });

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  reloadOrganizationSuppliers = async (supplierId: number | null) => {
    if (supplierId === null) {
      this.setState({
        organizationSuppliers: [],
        isLoading: false
      });
      return;
    }

    const organizationSupplierInterfaceTypes =
      await this.organizationService.GetOrganizationInterfaces(supplierId);

    this.setState({
      organizationSupplierInterfaceTypes: organizationSupplierInterfaceTypes,
      isLoading: false
    });
  };

  addOrganizationSupplier = async () => {
    try {
      if (this.state.organizationSupplierId === null) {
        if (
          this.state.organizationSuppliers.findIndex(
            (item) =>
              item.supplierId === this.state.selectedOrganizationSupplierType!.id &&
              item.supplierApiTypeId === this.state.supplierApiType!.id
          ) !== -1
        ) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate(
              'ERROR_MSG_WORKFLOW_SUPPLIER_EXISTS',
              'Furnizorul exista deja!'
            ),
            { variant: 'error' }
          );
          return;
        }
        await this.organizationService.AddOrganizationSupplier({
          id: 0,
          supplierId: this.state.selectedOrganizationSupplierType!.id,
          supplierInterfaceId: this.state.selectedOrganizationSupplierInterfaceType!.id,
          urlInterface: this.state.urlInterface,
          discountTariff: this.state.discountTariff,
          userName: this.state.userName,
          password: this.state.password,
          port: this.state.port,
          clientId: this.state.clientId,
          hasNonStockValidation: this.state.hasNonStockValidation,
          organizationId: this.state.organizationId,
          supplierApiTypeId: this.state.supplierApiType!.id,
          isActive: this.state.isActive
        } as OrganizationSupplier);
      } else {
        if (
          this.state.organizationSuppliers.findIndex(
            (item) =>
              item.supplierId === this.state.selectedOrganizationSupplierType!.id &&
              item.supplierApiTypeId === this.state.supplierApiType!.id &&
              item.id !== this.state.organizationSupplierId
          ) !== -1
        ) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate(
              'ERROR_MSG_WORKFLOW_SUPPLIER_EXISTS',
              'Furnizorul exista deja!'
            ),
            { variant: 'error' }
          );
          return;
        }

        await this.organizationService.UpdateOrganizationSupplier({
          id: this.state.organizationSupplierId,
          supplierId: this.state.selectedOrganizationSupplierType!.id,
          supplierInterfaceId: this.state.selectedOrganizationSupplierInterfaceType!.id,
          urlInterface: this.state.urlInterface,
          discountTariff: this.state.discountTariff,
          userName: this.state.userName,
          password: this.state.password,
          port: this.state.port,
          clientId: this.state.clientId,
          hasNonStockValidation: this.state.hasNonStockValidation,
          organizationId: this.state.organizationId,
          supplierApiTypeId: this.state.supplierApiType!.id,
          isActive: this.state.isActive
        } as OrganizationSupplier);
      }

      this.setState(
        {
          isLoading: true,
          isDialogOpen: false
        },
        async () => await this.loadOrganizationSuppliers()
      );

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleAutocompleteInterfaceChange = (newValue: any | null) => {
    this.setState({
      selectedOrganizationSupplierInterfaceType: newValue,
      urlInterface: newValue === null ? '' : newValue.url,
      port: newValue === null ? 80 : newValue.port
    });
  };

  handleAutocompleteSupplierChange = async (newValue: Organization | null) => {
    if (newValue === null) {
      this.setState({
        selectedOrganizationSupplierType: null,
        organizationSupplierInterfaceTypes: [],
        urlInterface: '',
        selectedOrganizationSupplierInterfaceType: null
      });
      return;
    }
    const orgInterfaceTypes = await this.organizationService.GetOrganizationInterfaces(newValue.id);
    this.setState({
      selectedOrganizationSupplierType: newValue,
      organizationSupplierInterfaceTypes: orgInterfaceTypes,
      selectedOrganizationSupplierInterfaceType: null
    });
  };

  private handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value: any;
    if (event.target.type === 'text' || 'password') {
      value = event.currentTarget.value;
    }
    this.setState({
      ...this.state,
      [event.target.id]: value
    });
  };

  handleDiscountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      discountTariff: event.target.value === null ? 0 : parseInt(event.target.value)
    });
  };

  handlePortChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ port: event.target.value === null ? 0 : parseInt(event.target.value) });
  };
  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            }
          });
        }}
        thousandSeparator
        decimalScale={2}
        isNumericString
        suffix=" %"
      />
    );
  };

  IntFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            }
          });
        }}
        min={0}
        decimalScale={0}
        isNumericString
      />
    );
  };

  public renderAddForm() {
    const isMultiple = this.state.organizationSupplierId === null ? true : false;
    return (
      <ValidatorForm onSubmit={(e) => this.addOrganizationSupplier()}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              id="suppliers"
              fullWidth
              options={this.state.organizationSupplierTypes.sort(function (a, b) {
                return a.name.localeCompare(b.name);
              })}
              value={this.state.selectedOrganizationSupplierType}
              onChange={(e: any, newValue: Organization | null) =>
                this.handleAutocompleteSupplierChange(newValue)
              }
              getOptionLabel={(option: Organization) => option.name}
              renderInput={(params) => (
                <TextValidator
                  {...params}
                  name="suppliers"
                  value={this.state.selectedOrganizationSupplierType}
                  label={this.translatorService.Tranlate(
                    'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_LABEL',
                    'Furnizor'
                  )}
                  fullWidth
                  validators={['required']}
                  errorMessages={[
                    this.translatorService.Tranlate(
                      'VALIDATORS_REQUIRED',
                      'Campul este obligatoriu'
                    )
                  ]}
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              id="interfaces"
              fullWidth
              options={this.state.organizationSupplierInterfaceTypes}
              value={this.state.selectedOrganizationSupplierInterfaceType}
              onChange={(e: any, newValue: OrganizationInterface | null) =>
                this.handleAutocompleteInterfaceChange(newValue)
              }
              getOptionLabel={(option: OrganizationInterface) => option.code || ''}
              renderInput={(params) => (
                <TextValidator
                  {...params}
                  name="interfaces"
                  value={this.state.selectedOrganizationSupplierInterfaceType}
                  label={this.translatorService.Tranlate(
                    'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_INTERFACE_LABEL',
                    'Interfata Furnizor'
                  )}
                  fullWidth
                  validators={['required']}
                  errorMessages={[
                    this.translatorService.Tranlate(
                      'VALIDATORS_REQUIRED',
                      'Campul este obligatoriu'
                    )
                  ]}
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              name="discountTariff"
              id="discountTariff"
              value={this.state.discountTariff}
              onChange={this.handleDiscountChange}
              label={this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_LABEL',
                'Discount (%)'
              )}
              validators={['required', 'minNumber:0', 'maxNumber:100']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
                this.translatorService.Tranlate(
                  'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                  'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
                ),
                this.translatorService.Tranlate(
                  'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_VALIDATORS_NUMBER_BETWENN',
                  'Valoarea discount-ului trebuie sa fie cuprinsa intre 0 si 100'
                )
              ]}
              InputProps={{
                inputComponent: this.NumberFormatCustom
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              name="userName"
              id="userName"
              value={this.state.userName}
              onChange={this.handleTextChange}
              label={this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_USERNAME_LABEL',
                'Utilizator'
              )}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              name="password"
              id="password"
              type="password"
              value={this.state.password}
              onChange={this.handleTextChange}
              label={this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_PASSWORD_LABEL',
                'Parola'
              )}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              name="port"
              id="port"
              value={this.state.port}
              onChange={this.handlePortChange}
              label={this.translatorService.Tranlate('WORKFLOW_SUPPLIERS_TAB_PORT_LABEL', 'Port')}
              InputProps={{
                inputComponent: this.IntFormatCustom
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              disableClearable
              id="supplierApiType"
              fullWidth
              options={this.state.supplierApiTypes}
              disabled={!this.state.supplierApiTypes.length}
              value={this.state.supplierApiType}
              onChange={(e: any, newValue: any | null) =>
                this.setState({ supplierApiType: newValue })
              }
              getOptionLabel={(option: any) => option.description}
              renderInput={(params) => (
                <TextValidator
                  {...params}
                  name="supplierApiType"
                  value={this.state.supplierApiType}
                  label={this.translatorService.Tranlate(
                    'DETAILS_OF_CAR_STATUS_LABEL1',
                    'Tip Api Furnizor'
                  )}
                  fullWidth
                  validators={['required']}
                  errorMessages={[
                    this.translatorService.Tranlate(
                      'VALIDATORS_REQUIRED',
                      'Campul este obligatoriu'
                    )
                  ]}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <TextValidator
              fullWidth
              name="urlInterface"
              id="urlInterface"
              value={this.state.urlInterface}
              onChange={this.handleTextChange}
              label={this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_INTERFACE_URL_LABEL',
                'URL'
              )}
              validators={['required']}
              errorMessages={[
                this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
              ]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              name="clientId"
              id="clientId"
              value={this.state.clientId}
              onChange={this.handleTextChange}
              label={this.translatorService.Tranlate(
                'WORKFLOW_SUPPLIERS_TAB_CLIENT_ID_LABEL',
                'Client Id'
              )}
            />
          </Grid>
        </Grid>

        <div className="text-right">
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('SAVE', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },

      {
        name: 'supplier.name',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_HEADER',
          'Furnizor'
        ),
        options: {
          customBodyRender: (value: Organization, tableMeta: MUIDataTableMeta) => {
            return (
              <Button
                color="primary"
                className="text-primary"
                onClick={(e) => this.newOrganizationSupplier(tableMeta.rowData[0])}
              >
                <span>{value}</span>
              </Button>
            );
          }
        }
      },
      {
        name: 'supplierInterface',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_INTERFACE_HEADER',
          'Interfata Furnizor'
        ),
        options: {
          sort: false,
          customBodyRender: (value: OrganizationInterface) => {
            return R.isNil(value) ? '' : value.code;
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'urlInterface',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIERS_TAB_SUPPLIER_INTERFACE_URL_HEADER',
          'URL'
        ),
        searchable: true,
        options: {
          setCellProps: () => ({ style: { maxWidth: '300px', 'overflow-wrap': 'break-word' } })
        } as MUIDataTableColumnOptions
      },
      {
        name: 'discountTariff',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIERS_TAB_DISCOUNT_HEADER',
          'Discount (%)'
        ),
        searchable: true
      },
      {
        name: 'userName',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIERS_TAB_USERNAME_HEADER',
          'Utilizator'
        ),
        searchable: true
      },
      {
        name: 'password',
        label: this.translatorService.Tranlate('WORKFLOW_SUPPLIERS_TAB_PASSWORD_HEADER', 'Parola'),
        options: {
          sort: false,
          filter: false,
          customBodyRender: (value: string, tableMeta: MUIDataTableMeta) => {
            return <span>***</span>;
          }
        }
      },
      {
        name: 'clientId',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIERS_TAB_CLIENT_ID_HEADER',
          'Client Id'
        ),
        searchable: true
      },
      {
        name: 'supplierApiTypeId',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIERS_TAB_PASSWORD_HEADER11',
          'Tip Api Furnizor'
        ),
        searchable: true,
        options: {
          customBodyRender: (value: number, tableMeta: MUIDataTableMeta) => {
            return this.state.supplierApiTypes.find((item) => item.id === value)!.description;
          }
        }
      },
      {
        name: 'isActive',
        label: this.translatorService.Tranlate('USERS_IS_ACTIVE_HEADER', 'Activ'),
        options: {
          sort: false,
          filterOptions: {
            names: [
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_ACTIVE', 'Activ'),
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_INACTIVE', 'Inactiv')
            ],
            logic(isActive: any, filterVal: string[]) {
              const show =
                (filterVal.indexOf(this.names[0]) !== -1 && isActive === true) ||
                (filterVal.indexOf(this.names[1]) !== -1 && isActive === false);
              return !show;
            }
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <Switch
                checked={value ? value : false}
                onChange={(e) => this.handleIsActiveChange(e, tableMeta)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            );
          }
        }
      },
      {
        name: 'hasNonStockValidation',
        label: this.translatorService.Tranlate(
          'WORKFLOW_SUPPLIERS_TAB_HAS_SUPPLIER_VALIDATION_LABEL',
          'Verificare furnizor'
        ),
        options: {
          sort: false,
          filterOptions: {
            names: [
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_ACTIVE', 'Activ'),
              this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_INACTIVE', 'Inactiv')
            ],
            logic(isActive: any, filterVal: string[]) {
              const show =
                (filterVal.indexOf(this.names[0]) !== -1 && isActive === true) ||
                (filterVal.indexOf(this.names[1]) !== -1 && isActive === false);
              return !show;
            }
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <Switch
                checked={value ? value : false}
                onChange={(e) => this.handleHasNonStockValidationChange(e, tableMeta)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            );
          }
        }
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <IconButton
                aria-label="delete"
                color="inherit"
                className="text-danger"
                size="small"
                onClick={(e) => this.deleteOrganizationSupplier(e, tableMeta)}
              >
                <DeleteOutlineTwoToneIcon />
              </IconButton>
            );
          }
        }
      }
    ];

    return columns;
  };

  deleteOrganizationSupplier = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.organizationService.RemoveOrganizationSupplier(id);
      await this.loadOrganizationSuppliers();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newOrganizationSupplier = async (supplierId: number | null) => {
    let newOrganizationSupplier: OrganizationSupplier;
    if (supplierId === null) {
      newOrganizationSupplier = { ...this.state.newOrganizationSupplier } as OrganizationSupplier;
      newOrganizationSupplier.organizationId = this.state.organizationId;
      newOrganizationSupplier.id = this.state.organizationSuppliers.length;
    } else {
      newOrganizationSupplier = this.state.organizationSuppliers.find(
        (item) => item.id === supplierId
      )!;
    }
    this.setState({
      newOrganizationSupplier: newOrganizationSupplier,
      selectedOrganizationSupplierType:
        supplierId === null ? null : newOrganizationSupplier.supplier,
      selectedOrganizationSupplierInterfaceType:
        supplierId === null ? null : newOrganizationSupplier.supplierInterface,
      urlInterface: supplierId === null ? '' : newOrganizationSupplier.urlInterface,
      discountTariff: supplierId === null ? 0 : newOrganizationSupplier.discountTariff,
      userName: supplierId === null ? '' : newOrganizationSupplier.userName,
      password: supplierId === null ? '' : newOrganizationSupplier.password,
      clientId: supplierId === null ? '' : newOrganizationSupplier.clientId,
      hasNonStockValidation:
        supplierId === null ? false : newOrganizationSupplier.hasNonStockValidation,
      port: supplierId === null ? null : newOrganizationSupplier.port,
      organizationSupplierId: supplierId,
      supplierApiType: this.state.supplierApiTypes.find(
        (item) => item.id === newOrganizationSupplier.supplierApiTypeId
      )!,
      isActive: supplierId === null ? true : newOrganizationSupplier.isActive,
      isDialogOpen: true
    });
  };

  closeDialog = async () => {
    this.setState({ isDialogOpen: false });
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.workflowService = (this.context as AppContext).workflowService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newOrganizationSupplier(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };

    return (
      <Fragment>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.organizationSuppliers}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        <Dialog
          onClose={this.closeDialog}
          aria-labelledby="customized-dialog-title"
          open={this.state.isDialogOpen}
          fullWidth={true}
          maxWidth={'md'}
        >
          <DialogTitle id="customized-dialog-title">
            <Grid container>
              <Grid item xs={11}>
                <Typography variant="h4">
                  {this.state.organizationSupplierId === null
                    ? this.translatorService.Tranlate(
                        'WORKFLOW_SUPPLIERS_TAB_NEW_MODAL_TITLE',
                        'Adauga furnizor'
                      )
                    : this.translatorService.Tranlate(
                        'WORKFLOW_SUPPLIERS_TAB_UPDATE_MODAL_TITLE',
                        'Actualizeaza furnizor'
                      )}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>{this.renderAddForm()}</DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(OrganizationSuppliers as any));
